import { useDispatch } from "react-redux";
import { useUpdateUserPhotoMutation } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import useGetAccountApi from "../Account/getAccountApi";

const useApiImageUploader = () => {
  const dispatch = useDispatch();
  const [changeImage] = useUpdateUserPhotoMutation();
  const getAccountApi = useGetAccountApi();

  const send = (file) => {
    dispatch(setLoader(true));
    const formdata = new FormData();
    formdata.append("image", file);
    changeImage(formdata)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        getAccountApi.get();
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useApiImageUploader;
